// نمایش و ورود مبالغ مالی — واحد نمایش «ریال»، ذخیرهٔ عددی خام.
// فقط برای مبالغ؛ تعداد/وزن/درصد از این توابع استفاده نکنند.
import React from "react";
import { InputNumber } from "antd";
import { moneyFormatter, moneyParser } from "./numberInput";
import { faNum } from "./faNumberFormat";
import { moneyWordsFa } from "./faWords";

export const MONEY_UNIT = "ریال";

/** خالی → "—" ؛ صفر → "۰" ؛ اعشار حذف؛ جداکنندهٔ سه‌رقمی فارسی. */
export function formatMoney(value, { unit = false, empty = "—" } = {}) {
  if (value === null || value === undefined || value === "") return empty;
  const n = Math.round(Number(value));
  if (!Number.isFinite(n)) return empty;
  const s = faNum(n);
  return unit ? `${s} ${MONEY_UNIT}` : s;
}

/** سلول جدول: فقط عدد (عنوان ستون «مبلغ (ریال)»). */
export function moneyCell(value) {
  return <span className="gx-money">{formatMoney(value)}</span>;
}

/** مبلغ با واحد — برای کارت/خلاصه. */
export function moneyWithUnit(value) {
  return <span className="gx-money">{formatMoney(value, { unit: true })}</span>;
}

export const moneyInputProps = {
  min: 0,
  style: { width: "100%" },
  className: "gx-money-input",
  formatter: moneyFormatter,
  parser: moneyParser,
};

/**
 * InputNumber مبلغ با فرمت سه‌رقمی.
 * previewLabel: زیر فیلد یک خط کوتاه مثل «مبلغ نهایی» (بدون تکرار عنوان فیلد).
 * v2.173.0: `words` ⇒ مبلغ به حروف زیرش (صفرِ اضافه با یک نگاه دیده شود) — در فرم‌های ثبتِ سند/پرداخت/انتقال روشن است؛
 * در سلول‌های جدول نه (ردیف بلند می‌شود).
 */
export function MoneyInput({ previewLabel, value, onChange, style, words: withWords, ...rest }) {
  const showPreview =
    previewLabel && value !== null && value !== undefined && value !== "";
  const words = withWords ? moneyWordsFa(value) : "";
  return (
    <div className="gx-money-field">
      <InputNumber
        {...moneyInputProps}
        {...rest}
        value={value}
        onChange={onChange}
        style={{ width: "100%", ...style }}
      />
      {showPreview && (
        <div className="gx-money-preview">
          {previewLabel}: {formatMoney(value, { unit: true })}
        </div>
      )}
      {words && <div className="gx-money-preview gx-money-words">{words}</div>}
    </div>
  );
}

/** تعداد خط با ارقام فارسی (بدون اعشارِ اضافه). */
function linesFa(stitchLines) {
  const lines = Number(stitchLines);
  return Number.isFinite(lines)
    ? faNum(lines, { maximumFractionDigits: 2 })
    : String(stitchLines);
}

/** برچسب عملیات با تعداد خط از نرخ‌نامه. */
export function operationLabel(name, stitchLines) {
  if (stitchLines == null || stitchLines === "") return name || "—";
  return `${name} (فی × ${linesFa(stitchLines)} خط)`;
}

/**
 * برچسب کوتاهِ عملیات — فقط «(N خط)».
 * در فرم‌های ثبت کارکرد استفاده می‌شود تا ردیف‌ها کوتاه و لیست خلوت بماند؛
 * مبلغ واحد به‌جای یک سطر توضیح، در tooltip نشان داده می‌شود.
 */
export function shortOpLabel(name, stitchLines) {
  if (stitchLines == null || stitchLines === "") return name || "—";
  return `${name} (${linesFa(stitchLines)} خط)`;
}
